export const GOAL_OPTIONS = [
  { key: 'MUSCLE_BUILD', value: 'MUSCLE_BUILD', label: 'Muscle Building', active: true },
  { key: 'WEIGHT_LOSS', value: 'WEIGHT_LOSS', label: 'Weight Loss', active: true },
  { key: 'MAINTAIN', value: 'MAINTAIN', label: 'Maintain', active: true }
];

export const ACTIVITY_LEVEL_OPTIONS = [
  { key: 'SEDENTARY', value: 'SEDENTARY', label: 'Sedentary (little/no exercise)', active: true },
  { key: 'LIGHT', value: 'LIGHT', label: 'Light (1-3 days/week)', active: true },
  { key: 'MODERATE', value: 'MODERATE', label: 'Moderate (3-5 days/week)', active: true },
  { key: 'ACTIVE', value: 'ACTIVE', label: 'Active (6-7 days/week)', active: true },
  { key: 'VERY_ACTIVE', value: 'VERY_ACTIVE', label: 'Very Active (physical job/training)', active: true }
];

export const BIOLOGICAL_SEX_OPTIONS = [
  { key: 'MALE', value: 'MALE', label: 'Male', active: true },
  { key: 'FEMALE', value: 'FEMALE', label: 'Female', active: true }
];

export const VARIETY_LEVELS = ['NONE', 'SOME', 'STRICT'];

export const VARIETY_LABELS = {
  NONE: 'None - repeat freely',
  SOME: 'Some - avoid repeating yesterday',
  STRICT: 'Strict - avoid repeating all week'
};
